import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ChartsLoader } from "@/components/charts/ChartsLoader";

export type TrendPoint = {
  label: string;
  value: number;
};

type TrendChartProps = {
  title: string;
  data: TrendPoint[];
  color?: string;
};

export function TrendChart({ title, data, color = "#f4b860" }: TrendChartProps) {
  return (
    <Card className="bg-background/40 border-border">
      <CardHeader>
        <CardTitle className="text-lg text-foreground">{title}</CardTitle>
      </CardHeader>
      <CardContent className="h-64">
        <ChartsLoader
          fallback={<p className="text-xs text-muted-foreground">Loading chart…</p>}
          errorFallback={<p className="text-xs text-muted-foreground">Chart unavailable.</p>}
        >
          {({ Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis }) => (
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={data}>
                <XAxis dataKey="label" stroke="#94a3b8" />
                <YAxis stroke="#94a3b8" />
                <Tooltip
                  contentStyle={{ backgroundColor: "#0f172a", borderColor: "#1e293b" }}
                  labelStyle={{ color: "#fff" }}
                />
                <Line type="monotone" dataKey="value" stroke={color} strokeWidth={2} dot={false} />
              </LineChart>
            </ResponsiveContainer>
          )}
        </ChartsLoader>
      </CardContent>
    </Card>
  );
}
